import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dob2age'
})
export class Dob2agePipe implements PipeTransform {

  //transform(value: any, args?: any): any {
  //  return null;
  //}

  transform(dob: string): number {

    if (!dob) {
      return null;
    }

    var d = +new Date() - +new Date(dob)    
    return d /1000/60/60/24/365 ;
  }
}

